export const TAG_SHEET_SAVE_SUCCESS_TOAST = 'Ads with creatives were created successfully';
export const TAG_SHEET_SAVE_FAILURE_TITLE = 'Failed to save tag sheet ads';
export const TAG_SHEET_SAVE_FAILURE_DESCRIPTION = 'An error occurred while saving. Please try again.';
export const TAG_SHEET_SAVE_ZERO_SUCCESS_TOAST_TITLE = 'No ads were created';
export const TAG_SHEET_SAVE_ZERO_SUCCESS_TOAST_DESCRIPTION = 'Review the results for details.';
